import styled, { css } from "styled-components";

import { Choose } from "../Choose/Choose";
import { Label } from "../Label";

export const StyledChoose = styled(Choose)`
  flex-shrink: 0;
  white-space: nowrap;

  ${(props) =>
    !props.active &&
    css`
      background-color: transparent !important;
    `}
`;

StyledChoose.displayName = "StyledChoose";

export const StyledVerticalContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

StyledVerticalContainer.displayName = "StyledVerticalContainer";

export const StyledLabel = styled(Label)<{ $disabled?: boolean }>`
  ${(props) =>
    !props.$disabled
      ? css`
          cursor: pointer;
        `
      : css`
          cursor: not-allowed;
        `}
`;

StyledLabel.displayName = "StyledLabel";

export const StyledRadioOption = styled.div<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 6px;

  ${(props) =>
    !props.$disabled
      ? css`
          cursor: pointer;
        `
      : css`
          cursor: not-allowed;
        `}

  &:hover {
    opacity: 0.8;
  }

  &[data-disabled="true"] {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

StyledRadioOption.displayName = "StyledRadioOption";

export const StyledFlexContainer = styled.div`
  display: flex;
  width: 100%;
`;

StyledFlexContainer.displayName = "StyledFlexContainer";
